export const PurchaseOrdersListingGetters = {
  PurchaseOrders: 'purchaseOrders',
  PurchaseOrdersSortOrder: 'purchaseOrdersSortOrder',
  PurchaseOrdersSortBy: 'purchaseOrdersSortBy',
  PurchaseOrdersSortDirection: 'purchaseOrdersSortDirection',
  PurchaseOrdersCount: 'purchaseOrdersCount',
  PurchaseOrdersPerPage: 'purchaseOrdersPerPage',
  PurchaseOrdersListingOffset: 'purchaseOrdersListingOffset',
  PurchaseOrdersSearchParam: 'purchaseOrdersSearchParam',
  PurchaseOrdersLoading: 'purchaseOrdersLoading'
};
export const PurchaseOrdersListingMutations = {
  SetPurchaseOrders: 'setPurchaseOrders',
  SetPurchaseOrdersSortOrder: 'setPurchaseOrdersSortOrder',
  SetPurchaseOrdersCount: 'setPurchaseOrdersCount',
  SetPurchaseOrdersPaginationParameters: 'setPurchaseOrdersPaginationParameters',
  SetPurchaseOrdersStatusFilterPreference: 'setPurchaseOrdersStatusFilterPreference',
  SetPurchaseOrdersTypeFilterPreference: 'setPurchaseOrdersTypeFilterPreference',
  ResetPurchaseOrdersPaginationOffset: 'resetPurchaseOrdersPaginationOffset',
  SetPurchaseOrdersLoading: 'setPurchaseOrdersLoading',
  SetPurchaseOrdersSearchParam: 'setPurchaseOrdersSearchParam'
};
export const PurchaseOrdersListingActions = {
  RetrievePurchaseOrders: 'retrievePurchaseOrders',
  SetPurchaseOrdersSortOrder: 'setPurchaseOrdersSortOrder',
  RetrievePurchaseOrdersCount: 'retrievePurchaseOrdersCount',
  SetPurchaseOrdersPaginationParameters: 'setPurchaseOrdersPaginationParameters',
  PurchaseOrdersFilterPreferenceUpdate: 'purchaseOrdersFilterPreferenceUpdate',
  PurchaseOrdersTypeFilterPreferenceUpdate: 'purchaseOrdersTypeFilterPreferenceUpdate',
  SetPurchaseOrdersLoading: 'setPurchaseOrdersLoading',
  UpdatePurchaseOrdersList: 'updatePurchaseOrdersList'
};
